
































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { FeedMessageEntity } from "@/api/types";
import WriteMessage from "@/components/WriteMessage.vue";
import FeedReply from "@/components/FeedReply.vue";
import moment from "moment";
//@ts-ignore
import LinkPrevue from 'link-prevue';


@Component({
  components: {
    LinkPrevue,
    FeedReply
  }
})
export default class FeedMessage extends Vue {
  
  links: string[] = [];

  @Prop()
  readonly message!: FeedMessageEntity;
  onFormat(value: any , type: any) {
    console.log(value);
    console.log(type);
    if(type === 'url') {
      this.links.push(value);
    }
    return value;
  }

  get firstLink() {
    if(this.links.length > 0) {
      return this.links[0];
    }
    return "";
  }

  get posted() {
    const now = moment(Date.now());
    const posted = moment(this.message.timestamp);
    return posted.from(now);
  }

  reply() {
    console.log(this.message);
    let options = {
      component: WriteMessage, 
      componentProps: { 
        data: { replyTo: this.message.id }
      }
    }
    this.$ionic.modalController.create(options).then(m => m.present())
  }
}
